var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inPreview
    ? _c(
        "div",
        [
          _vm.generatingPreview
            ? _c(
                "div",
                { staticClass: "relative" },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%", height: "60vh" }
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "absolute top-0 left-0 w-100 h-100 d-flex justify-center items-center gap-4"
                    },
                    [
                      _c("b-spinner"),
                      _c("span", [_vm._v("Generando previsualización")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-overlay",
            {
              attrs: { show: _vm.saving },
              scopedSlots: _vm._u(
                [
                  {
                    key: "overlay",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center align-items-center"
                          },
                          [
                            _c("b-spinner", { staticClass: "mr-2" }),
                            _c("small", [_vm._v("Creando documento...")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                3697303761
              )
            },
            [
              !_vm.generatingPreview && _vm.pdfUrl !== "" && _vm.pdfUrl != null
                ? _c("iframe", {
                    staticClass: "w-100",
                    staticStyle: { height: "70vh" },
                    attrs: {
                      src: _vm.pdfUrl,
                      name: "pdfPreviewIframe",
                      title: "pdfPreviewIframe"
                    }
                  })
                : _vm._e(),
              !_vm.generatingPreview
                ? _c(
                    "div",
                    { staticClass: "absolute top-0 left-0 z-10" },
                    [
                      _c(
                        "vx-tooltip",
                        {
                          attrs: {
                            text: "Recargar previsualización",
                            placement: "top"
                          }
                        },
                        [
                          _c("vs-button", {
                            staticClass: "ml-4 mt-4",
                            attrs: {
                              size: "small",
                              color: "primary",
                              icon: "refresh"
                            },
                            on: { click: _vm.handlePreview }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _c(
            "div",
            { staticClass: "row justify-end" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mt-5 mr-5",
                  attrs: {
                    "data-cy": "cancel",
                    color: "primary",
                    disabled: _vm.generatingPreview || _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.setInPreview(false)
                    }
                  }
                },
                [_vm._v(" Volver ")]
              ),
              _c(
                "vs-button",
                {
                  staticClass: "mt-5 mr-5",
                  attrs: {
                    "data-cy": "save",
                    color: "success",
                    disabled: _vm.generatingPreview || _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("save")
                    }
                  }
                },
                [_vm._v(" Crear ")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }